<template>
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs12 sm12 md6 lg6>
        <v-card>
          <v-card-title class="align-center justify-center">
            <span class="text-center title font-weight-medium">
              Yeni Doğum günü Şablonu Kaydet
            </span>
            <v-flex d-flex>
              <v-layout justify-end>
                <v-btn text @click.stop="deleteTemplate">Şablonu Kaldır</v-btn>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid" ref="form" lazy-validation>
              <v-select
                v-model="data.template.message_platform"
                :items="messagePlatforms"
                label="Gönderim Platformu"
                :rules="[$rules.selection('Gönderim Platformu')]"
                required
              ></v-select>

              <v-select
                v-if="data.template.message_platform === 'Whatsapp'"
                v-model="data.template.whatsapp_sender"
                :items="whatsappSenders"
                label="Gönderici Adı"
                :rules="[$rules.selection('Gönderici Adı')]"
                required
              ></v-select>
              <v-select
                v-if="data.template.message_platform !== 'Whatsapp'"
                v-model="data.template.message_type"
                :items="messageType"
                label="Tür"
                :rules="[$rules.selection('Tür')]"
                required
              ></v-select>

              <senders-or-message-types
                v-if="data.template.message_platform !== 'Whatsapp'"
                label="Gönderici Adı"
                no-data-text="Aktif Gönderici Adı bulunmuyor"
                :default="data.template.sender"
                :rules="[$rules.selection('Gönderici Adı')]"
                :items="data.senders"
                @on:model-update="(val) => { data.template.sender = val; }"
              ></senders-or-message-types>

              <v-container grid-list-md fluid>
                <v-layout row>
                  <button-keys
                    :keys="data.keys"
                    item-value="value"
                    @on:button-key="(val) => { data.template.message += ` ${val}`; }"
                  ></button-keys>
                </v-layout>
              </v-container>

              <v-textarea
                v-model="data.template.message"
                :rules="[$rules.empty('Mesaj')]"
                label="Mesajınız"
                rows="14"
                shaped
                required
              ></v-textarea>

              <v-file-input
                v-if="data.template.message_platform === 'Whatsapp'"
                v-model="data.template.image"
                label="Resim Ekle (Opsiyonel)"
                accept="image/*"
                prepend-icon="mdi-image"
              ></v-file-input>

              <v-btn @click="saveTemplate">
                Şablonu Kaydet
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { types } from '../../../../misc';
import ButtonKeys from '../../../Components/SMSConstants/ButtonKeys.vue';
import SendersOrMessageTypes from '../../../Components/SMSConstants/SendersOrMessageTypes.vue';

export default {
  name: 'Index',
  data: () => ({
    valid: true,
    data: {
      keys: [],
      senders: [],
      whatsapp_senders: [],
      template: {
        sender: '',
        message: '',
        message_type: '',
        message_platform: 'SMS',
        whatsapp_sender: '',
        image: null, // Resim dosyasını tutmak için eklendi
      },
    },
    whatsappSenders: [], // Whatsapp göndericilerini tutacak dizi
    messagePlatforms: ['Whatsapp', 'SMS'], // Gönderim tipleri
    messageType: ["turkce", "normal", "unicode"], // Gönderim tipleri
    types,
  }),
  components: { SendersOrMessageTypes, ButtonKeys },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    saveTemplate() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append('sender', this.data.template.sender);
        formData.append('message', this.data.template.message);
        formData.append('message_type', this.data.template.message_type);
        formData.append('message_platform', this.data.template.message_platform);
        formData.append('whatsapp_sender', this.data.template.whatsapp_sender);
        if (this.data.template.image) {
          formData.append('image', this.data.template.image);
        }

        this.send({
          route: 'update/birthday/template',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
    },
    deleteTemplate() {
      this.send({ route: 'delete/birthday/template' })
        .then(() => {
          this.$refs.form.reset();
        });
    },
  },
  created() {
    this.send({ route: 'show/birthday/template' })
      .then((res) => {
        this.data.template.message_type = res.data.data.default_message_type;
        if (res.data.data.template) {
          this.data.template = res.data.data.template;
        }

        this.data.keys = res.data.data.keys;
        this.data.senders = res.data.data.senders;
        this.data.whatsapp_senders = res.data.data.whatsapp_senders;

        // Whatsapp göndericilerini formata dönüştür
        this.whatsappSenders = this.data.whatsapp_senders.map(sender => sender.sender);

        // Whatsapp gönderici adı seçili hale getirme
        if (this.data.template.message_platform === 'Whatsapp' && this.data.template.sender) {
          this.data.template.whatsapp_sender = this.data.template.sender;
        }
      });
  },
};
</script>
